import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["scroller", "content"]

  connect() {
    this.update()

    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(() => this.update())
      this.observer.observe(this.contentTarget)
      this.observer.observe(this.scrollerTarget)
    }

    this.onResize = () => this.update()
    window.addEventListener("resize", this.onResize)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    window.removeEventListener("resize", this.onResize)
  }

  update() {
    const el = this.scrollerTarget
    const hasMoreBelow = el.scrollHeight - el.scrollTop - el.clientHeight > 1

    this.element.classList.toggle("--is-scrollable", hasMoreBelow)
  }
}
